export type Spirit={name:string;kind:string;color:string;accent:string;eyes:string;rarity:string;hp:number;points:number;radius:number};
export const SPIRITS:Spirit[]=[
{name:'먹구름 악령',kind:'cloud',color:'#d4b9ff',accent:'#8063dc',eyes:'#2d2456',rarity:'일반',hp:3,points:100,radius:70},
{name:'심연의 물귀신',kind:'bubble',color:'#89ecf5',accent:'#36a9db',eyes:'#183f70',rarity:'일반',hp:3,points:120,radius:65},
{name:'구미호 원혼',kind:'fox',color:'#ffd18b',accent:'#f58a62',eyes:'#513064',rarity:'희귀',hp:4,points:210,radius:70},
{name:'쌍뿔 야차',kind:'horn',color:'#ff96c7',accent:'#ce50a0',eyes:'#3c2455',rarity:'희귀',hp:5,points:260,radius:70},
{name:'흑염 용귀',kind:'dragon',color:'#96c8ff',accent:'#5e71e3',eyes:'#252a67',rarity:'전설',hp:7,points:500,radius:78},
{name:'저주받은 인형',kind:'doll',color:'#c1a5a6',accent:'#c76c89',eyes:'#d62d53',rarity:'일반',hp:3,points:130,radius:65},
{name:'망자의 갑주',kind:'knight',color:'#7b9b81',accent:'#69bf90',eyes:'#7dffb1',rarity:'희귀',hp:5,points:280,radius:72},
{name:'거미 원귀',kind:'spider',color:'#9c87c2',accent:'#9e72ec',eyes:'#c897ff',rarity:'희귀',hp:4,points:240,radius:72},
{name:'혼불 사신',kind:'reaper',color:'#91b7cc',accent:'#70d7ed',eyes:'#92f8ff',rarity:'전설',hp:6,points:420,radius:76},
{name:'서리 악귀',kind:'frost',color:'#c5e8ff',accent:'#8bd9ff',eyes:'#d2f8ff',rarity:'일반',hp:4,points:160,radius:68}
];

export function chooseSpirit(random: () => number = Math.random): number {
 const rarity = random() < .12 ? '전설' : random() < .34 ? '희귀' : '일반';
 const pool = SPIRITS.map((spirit, index) => ({ spirit, index })).filter(entry => entry.spirit.rarity === rarity);
 return pool[Math.min(pool.length - 1, Math.floor(random() * pool.length))].index;
}
